import React from "react";

class ImageLoader extends React.Component {
  _isMounted = true;
  constructor(props) {
    super(props);
    this.state = {
      isError: false,
      isLoaded: false,
    };
    this.setErrorTrue = this.setErrorTrue.bind(this);
    this.setLoadedTrue = this.setLoadedTrue.bind(this);
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;
  }

  setErrorTrue = () => {
    if (this._isMounted) {
      this.setState({ isError: true });
    }
  };
  setLoadedTrue = () => {
    if (this._isMounted) {
      this.setState({ isLoaded: true, isError: false });
    }
  };
  render() {
    return (
      <React.Fragment>
        <img
          src={!!this.props.image ? this.props.image : this.props.fallbackImage}
          alt={this.props.showAlt ? this.props.alt : this.props.cname}
          aria-label={this.props.showAlt ? this.props.alt : this.props.cname}
          title={this.props.showTitle ? this.props.title : ""}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = this.props.fallbackImage;
            e.target.alt = "";
            e.target.title = "";
          }}
          width={!!this.props.width && this.props.width}
          height={!!this.props.height && this.props.height}
        />
      </React.Fragment>
    );
  }
}

export default ImageLoader;
